import type { Role } from './roles';

/** Who may open a screen. Owners see everything; workers only see jobs and their account. */
export const STAFF: Role[] = ['owner', 'office'];
export const ALL: Role[] = ['owner', 'office', 'worker'];
export const OWNER: Role[] = ['owner'];
